export default "__VITE_ASSET__qcy307yT__"